import 'rxjs/add/operator/debounceTime';
import {Component, ViewChild} from '@angular/core';
import {Keyboard, NavController, NavParams, TextInput, ViewController} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";
import {TAcessoFind, TAction, TPaybookTipo, TPrecifyMenu, TProfileTeam, TProdutoImpresso, TProdutoSale, TPaybookFlag} from "../../../app/enum";

import {DataService} from '../../../providers/data-service';
import {LogadoService} from "../../../providers/logado-service";

import {ConsumoSalePage} from '../consumo-sale/consumo-sale';

@Component({
    selector: 'page-lancaki-menu',
    templateUrl: 'lancaki-menu.html',
    providers: []
})
export class LancakiMenuPage {
    
    TPaybookTipo: any = TPaybookTipo;
    TProdutoSale: any = TProdutoSale;
    TProdutoImpresso: any = TProdutoImpresso;

    config: any;
    etapa: number;
    hotspotID: number;

    akkjson = (window as any).handappMainInstance.appjson;
    monitorAuth = this.akkjson.hotwork;

    finddata: string;
    produtoText: boolean;
    produtoFind: any[] = [];

    
    
    //Etapa - 5
    monitorBool: boolean;
    requestIpad: boolean;
    rootComanda: any;

    textdata: any;
    comandaIN: number = 0;
    clusterIN: number = 0;
    vendidoShow: number;
    produtoStar: any = [];
    tecladoMesa: number = 0;
    mesafix: number = 0;
    seatfix: number = 0;

    productTime: number;


    @ViewChild('inputProduto') inputProduto: TextInput;

    constructor(public viewCtrl: ViewController, public navCtrl: NavController, public navParams: NavParams,
                public logadoService: LogadoService,
                public util: Util,
                public dataService: DataService,
                public keyboard: Keyboard) {

        this.config = CONFIG;
        this.etapa = this.util.anyParams(0, this.navParams.get('etapa'));

        //
        this.hotspotID = this.util.anyParams(0, this.navParams.get('hotspotID'));

        this.monitorBool = this.navParams.get('monitorBool');
        this.rootComanda = this.navParams.get('rootComanda');

        this.comandaIN = this.util.anyParams(0, this.navParams.get('comandaIN'));
        this.clusterIN = this.navParams.get('clusterIN');

        
        //#IPAD-BARMAN
        this.requestIpad = this.util.anyParams(false, this.navParams.get('requestIpad'));


        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Lancaki', '/lancaki-menu');

        if (this.etapa == 5) this.comandaInit(this.comandaIN);
        if (this.etapa == 9) this.clusterLoad();

        //Hide Support Button Fab
        (window as any).handappMainInstance.supportShow = false;

    }

    ionViewDidLoad() {

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }

    getTitle() {

        let comanda = this.rootComanda.Comandas[this.comandaIN];
        let clusterMenu = (this.monitorAuth.clusterRoot ? this.monitorAuth.clusterRoot.ClusterMenu : 0);
        let pracetaBool = (comanda.Mesa == null || comanda.Seat == null);

        if (this.etapa == 5 && pracetaBool)         return 'Praça';
        if (this.etapa == 5 && this.clusterIN < 0)  return 'Preço ' + (clusterMenu >= 0 ? TPrecifyMenu[clusterMenu].slice(2, 99) : '');
        if (this.etapa == 5 && this.clusterIN >= 0) return this.monitorAuth.clusterRoot.Clusters[this.clusterIN].ClusterNome;
        if (this.etapa == 8) return (comanda.Mesa ? 'Mesa ' + comanda.Mesa : 'Lançado');
        
        if (this.etapa == 9) return (this.monitorAuth.clusterRoot ? this.util.dinheiro(this.paymentItem()) : 'Cardápio');

    }

    inputLupa($event) {

        this.finddata = '';
        this.produtoText = !this.produtoText;
        if (!this.produtoText) return;

        setTimeout(() => {
            if (this.inputProduto) this.inputProduto.setFocus();
        }, 800);

    }

    tecladoOkey(btn) {
        
        if (btn == 'ok') {            
            this.comandaMesa(this.tecladoMesa);
            this.clusterShow('mesa');
        }

        else if (btn == 'cancel') {
            
        }

        else if (btn == 'erase') {
            this.tecladoMesa = 0;
        }

        else if (btn == 'left-thin') {
            let length = this.tecladoMesa+''.length;
            if (length == 1) this.tecladoMesa = 0;
            if (length > 1)  this.tecladoMesa = parseInt(this.tecladoMesa+''.slice(0, length-1));
        }

        else if (btn == 'dot') {
            //
        }

        else {
            //Mesamax: 999
            if (this.etapa == 5 && (this.tecladoMesa+'').length > 2) return;
            
            this.tecladoMesa = parseInt(this.tecladoMesa + (btn + ''));
        }

    }

    produtoSort() {

        let produtoStar = [];
        if (this.clusterIN < 0)  this.monitorAuth.clusterRoot.Clusters.forEach(CL => CL.Produtos.forEach(PD => produtoStar.push(PD)));
        if (this.clusterIN >= 0) this.monitorAuth.clusterRoot.Clusters[this.clusterIN].Produtos.forEach(PD => produtoStar.push(PD));

        this.produtoStar = this.util.arraySort(produtoStar, 'ProdutoStar');
        produtoStar.reverse();

    }

    bmaskerMask() {

        let size = (this.textdata || '').replace('.', '').length;
        let mask = (size <= 4 ? '0000' : (size == 5 ? '00.000' : '000.000.000-00'));
        return {mask: mask, type: 'num', len: mask.length};

    }

    comandaFind(force) {

        if (!this.util.validaCNPF(this.textdata) && !force) return;

        let onPush = (data) => {
            this.textdata = '';

            let array = this.rootComanda.Comandas;
            let comanda = (data.Comandas || [])[0];

            if (!comanda) {
                this.util.alertSimply('Não encontrado');
                return;
            }

            if (comanda && comanda.PaybookBora) {
                this.util.alertSimply('Checkout Realizado');
                return;
            }

            if (comanda && comanda.PaybookFlag > TPaybookFlag.pfOpen) {
                this.util.alertSimply('Checkin Travado');
                return;
            }

            if (comanda) {
                let index = array.findIndex(CO => CO.ComandaID == comanda.ComandaID);
                if (index < 0) {
                    array.push({});
                    index = array.length-1;
                }
                this.util.populateObj(array[index], comanda);
                this.comandaInit(index);
            }

        };

        let rnrn = this.util.validaCNPF(this.textdata);
        let params = '&ComandaText=' + this.textdata +
                     '&ComandaMode=' + (rnrn ? TAcessoFind.afFindRnid : TAcessoFind.afFindNoro);

        let loading = this.util.loadingDots();
        loading.present();

        this.util.monitorDesk(this.monitorBool, 'DESK-Comanda', this.hotspotID, params, TAction.acFind)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onPush(data),
                erro => this.util.alertResult(erro));

    }

    comandaInit(index) {

        this.comandaIN = index;

        //#Gamb -> Quando tem 1 unica sala, seleciona!
        if (this.rootComanda.Comandas[this.comandaIN].Ambient.AmbientRoom.length == 1) this.rootComanda.Comandas[this.comandaIN].Ambient.AmbientSala = 0;

        if (this.rootComanda.Comandas[this.comandaIN].Mesa >= 0) {
            this.produtoSort();
            this.vendidoShow = this.produtoStar.length > 5 ? 1 : 0;
            this.etapa = 5;
            return;
        }

        if (this.rootComanda.Comandas[0].PaybookTipo == TPaybookTipo.pbCard) {
            let room = this.rootComanda.Comandas[this.comandaIN].Ambient.AmbientRoom;
            let seat = this.rootComanda.Comandas[this.comandaIN].Ambient.AmbientSeat;
            let mesa = (index > 0 ? this.rootComanda.Comandas[0].Mesa : (room ? null : 0));
            let seak = (mesa > 0 && seat ? null : (room && seat && mesa == null ? null : 0));

            //if (mesa == null) delete this.rootComanda.Comandas[this.comandaIN].Mesa
            //else this.rootComanda.Comandas[this.comandaIN].Mesa = mesa;

            //if (seat == null) delete this.rootComanda.Comandas[this.comandaIN].Seat
            //else this.rootComanda.Comandas[this.comandaIN].Seat = seak;

            this.rootComanda.Comandas[this.comandaIN].Mesa = mesa;
            this.rootComanda.Comandas[this.comandaIN].Seat = seak;
            this.seatfix = 0;

            //MESAFIX-FIXA -> #OBARA - Fixar mesa para impressao de andares diferentes no PRACA A!
            let mesafixNoro = this.dataService.get('MESAFIX-FIXA');
            if (mesafixNoro) {
                this.tecladoMesa = mesafixNoro;
                this.tecladoOkey('ok');
            }

        }

        if (this.rootComanda.Comandas[0].PaybookTipo == TPaybookTipo.pbMesa) {
            this.rootComanda.Comandas[this.comandaIN].Mesa = this.rootComanda.Comandas[this.comandaIN].PaybookNoro;
            this.rootComanda.Comandas[this.comandaIN].Seat = 0;
        }

        this.etapa = 5;

        if (!this.requestIpad) this.clusterLoad();

    }

    sectoreMesa() {

        let result = [];

        let room = this.rootComanda.Comandas[this.comandaIN].Ambient.AmbientRoom;
        let sala = this.rootComanda.Comandas[this.comandaIN].Ambient.AmbientSala;

        if (room && sala != null) {
            let start = this.util.jsSum(room.filter((x, i) => i < sala), ['Qtde']) + 1;
            let acaba = start + room[sala].Qtde - 1;
            for (let i = start; i <= acaba; i++) result.push(i);
        }

        return result;

    }

    comandaMesa(mesa) {

        if (mesa) {
            this.mesafix = mesa;
            this.util.impact();
            return;
        }
        
    }

    comandaSeat(seat) {

        this.seatfix = seat;
        this.util.impact();

    }

    consumoSoma(): number {

        let result = 0;
        this.rootComanda.Comandas.forEach(PB => {

            PB.Consumos.forEach(CS => {
                result = result + (CS.Consumo.ConsumoQtde * CS.Consumo.ConsumoCash) - CS.Consumo.ConsumoLess;
            });

        });
        return result;

    }

    mesafixFixa() {

        let mesafixNoro = (this.tecladoMesa ? this.tecladoMesa : null);
        this.dataService.set('MESAFIX-FIXA', mesafixNoro);

        this.tecladoOkey('ok');

    }

    clusterShow(show: 'mesa' | 'seat') {

        // Uma Unica mesa na praça, seta a primeira 
        let mesalist = this.sectoreMesa();
        if (!this.mesafix && !this.mesafix && mesalist.length == 1) this.mesafix = mesalist[0];

        this.rootComanda.Comandas[this.comandaIN].Mesa = (this.mesafix || 0);


        // Seat não selecionado ou desativado
        let seat = this.rootComanda.Comandas[this.comandaIN].Ambient.AmbientSeat;
        if (!seat || show == 'seat')
        this.rootComanda.Comandas[this.comandaIN].Seat = (this.seatfix || 0);



        //#IPAD-BARMAN
        let seatnull = (this.rootComanda.Comandas[this.comandaIN].Seat == null);
        if (!seatnull && this.requestIpad) this.dismiss();

    }

    clusterOpen(clusterIN) {

        let comanda = this.util.deepCopy(this.rootComanda.Comandas[this.comandaIN]);
        this.rootComanda.Dividirs = [comanda];

        let object = {etapa: 5, monitorBool: this.monitorBool, hotspotID: this.hotspotID, rootComanda: this.rootComanda, comandaIN: this.comandaIN, clusterIN: clusterIN};
        this.util.modalopen(LancakiMenuPage, 'alto', false, object).subscribe();
        
    }

    clusterLoad() {

        let hotspotID = this.monitorAuth.Hotspot.HotspotID;
        let consumoPedy = (this.monitorAuth.clusterRoot ? this.monitorAuth.clusterRoot.ConsumoPedy : 0);

        let onLoad = (root) => {
            //data.ConsumoPedy
            this.akkjson.hotwork.clusterRoot = root;
            this.monitorAuth.clusterRoot = root;

            /* ProdutoStar */
            this.produtoSort();
            this.vendidoShow = this.produtoStar.length > 5 ? 1 : 0;
        };

        let onErro = (erro) => {
            erro.Titulo = this.monitorAuth.Hotspot.HotspotHoip;
            this.util.alertResult(erro);
        };

        let loading = this.util.loadingDots();
        loading.present();

        let params = '&ComandaID=' + this.rootComanda.Comandas[this.comandaIN].ComandaID + '&ConsumoPedy=' + consumoPedy;

        let request;
        if (this.etapa != 9) request = this.util.monitorDesk(this.monitorBool, 'DESK-Cluster', hotspotID, params, TAction.acSale);
        if (this.etapa == 9) request = this.util.monitorDesk(this.monitorBool, 'DESK-Started', hotspotID, params, TAction.acItem);

        request
            .finally(() => loading.dismiss())
            .subscribe(
                root => onLoad(root),
                erro => onErro(erro));

    }

    //PRODUCT
    produtoLupa() {

        let produtoGtin = false;

        this.produtoFind = [];
        this.monitorAuth.clusterRoot.Clusters.forEach(CL => {
            CL.Produtos.forEach(PD => {
                if (PD.ProdutoID == this.finddata || PD.ProdutoGtin == this.finddata || PD.ProdutoNome.toUpperCase().indexOf(this.finddata.toUpperCase()) >= 0) {
                    produtoGtin = (PD.ProdutoGtin && PD.ProdutoGtin == this.finddata);
                    this.produtoFind.push(PD);
                }
            });
        });

        clearTimeout(this.productTime);
        this.productTime = setTimeout(() => {
            if (produtoGtin && this.produtoFind.length == 1) {
                this.produtoOpen(this.produtoFind[0]);

                //Limpa depois da Rotina this.produtoOpen()...
                this.produtoFind = [];
                this.finddata = '';
            }
        }, 500);

    }

    produtoOpen(rowline) {

        let onThen = () => {

            //Sai do grupo
            //if (this.clusterIN >= 0) this.navCtrl.getActive().dismiss();
            if (this.clusterIN >= 0) this.dismiss();

            //Sai da pesquisa
            if (this.clusterIN < 0) {
                this.finddata = '';
                this.produtoText = false;
            };

        }

        let comanda = this.util.deepCopy(this.rootComanda.Comandas[this.comandaIN]);
        this.rootComanda.Dividirs = [comanda];

        let cluster = this.monitorAuth.clusterRoot.Clusters[this.clusterIN];
        if (!cluster) cluster = this.monitorAuth.clusterRoot.Clusters.filter(CL => (CL.Produtos.findIndex(PD => PD.ProdutoID == rowline.ProdutoID)) >= 0)[0];
        let clusterIN = this.monitorAuth.clusterRoot.Clusters.findIndex(CL => CL.ClusterID == cluster.ClusterID);

        let object = {etapa: 6, monitorBool: this.monitorBool, hotspotID: this.hotspotID, rootComanda: this.rootComanda, comandaIN: this.comandaIN, clusterIN: clusterIN, itemProduto: rowline, itemEscolha: cluster.ClusterText};
        this.util.modalopen(ConsumoSalePage, 'alto', false, object, null, null, null, onThen).subscribe()

    }




    //PRINTER
    printerItem(spol) {

        //GAMBI - Corrigindo o Click do Usuario
        if (this.textdata) {
            this.comandaFind(true);
            return;
        }

        let onDone = () => {
            //#ConsumoPedy - Limpa para pedir um novo numero de Pedido (fechando e voltando para o menu)
            this.akkjson.hotwork.clusterRoot = null;
            this.rootComanda.Comandas.forEach(CO => delete CO.Mesa);
            this.rootComanda.Comandas.forEach(CO => delete CO.Seat);
            this.navCtrl.getPrevious().dismiss();  //#G - Force close PaybookMenu finalizou tudo "AGILIDADE"!
            this.dismiss();
        }

        let loading = this.util.loadingDots();
        loading.present();

        let params = '&ConsumoPedy=' + this.monitorAuth.clusterRoot.ConsumoPedy + 
                     '&Impresso=' + spol;
        this.util.monitorDesk(this.monitorBool, 'DESK-Printer', this.hotspotID, params, TAction.acItem)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onDone(),
                erro => this.util.alertResult(erro)
            );

    }


    consumoMenu(comandaIN, consumoIN) {

        let onDone = () => {

            let consumoID = this.rootComanda.Comandas[comandaIN].Consumos[consumoIN].Consumo.ConsumoID;
            this.rootComanda.Comandas[comandaIN].Consumos.splice(consumoIN, 1);
            for (let i = this.rootComanda.Comandas[comandaIN].Consumos.length-1; i >= 0; i--) {
                if (this.rootComanda.Comandas[comandaIN].Consumos[i].Consumo.AdicionalID == consumoID) {
                    this.rootComanda.Comandas[comandaIN].Consumos.splice(i, 1);
                }
            }

        };

        let onLixo = () => {

            let loading = this.util.loadingDots();
            loading.present();

            let params = '&ConsumoID=' + this.rootComanda.Comandas[comandaIN].Consumos[consumoIN].Consumo.ConsumoID;

            this.util.monitorDesk(this.monitorBool, 'DESK-Consumo', this.hotspotID, params, TAction.acLixo)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => onDone(),
                    erro => this.util.alertResult(erro)
                );

        };

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Excluir', handler: () => onLixo(), role: 'destructive'});
        this.util.sheetOpen(buttons, 'ACTION', 0);

    }

    consumoLoad() {

        if (!this.monitorAuth.clusterRoot) {
            this.dismiss(true);
            return;
        }

        let count = 0;
        let loading = this.util.loadingDots();
        loading.present();

        let array = this.rootComanda.Comandas;

        array.forEach((CM, index) => {

            let onDone = () => {
                count++;

                if (count >= index + 1) {

                    if (loading) loading.dismiss();
                    loading = null;

                    let consumoQtde = this.util.jsCount(this.rootComanda.Comandas, ['Consumos', 'Consumo', 'ConsumoID']);
                    if ( consumoQtde) this.etapa = 8;
                    if (!consumoQtde) this.dismiss(true);

                }
            };

            let params = '&ComandaID=' + CM.ComandaID + '&ConsumoPedy=' + this.monitorAuth.clusterRoot.ConsumoPedy;
            this.util.monitorDesk(this.monitorBool, 'DESK-Consumo', this.hotspotID, params, TAction.acBook)
                .finally(() => onDone())
                .subscribe(
                    data => CM.Consumos = data.Consumos,
                    erro => this.util.alertResult(erro)
                );

        });

    }



    paymentItem(): number {

        let paymentSoma = 0;
        this.monitorAuth.clusterRoot.Clusters.forEach(CL => CL.Produtos.forEach(PD => {
            if (PD.ProdutoBola) paymentSoma = paymentSoma + (PD.ProdutoBola * PD.PrecifyCash);
        }));

        return paymentSoma;

    }

    paymentQtde(soma, rowline, event?) {

        if (event) event.stopPropagation();

        if (rowline.ProdutoBola == 0 && !soma) return;

        if (!rowline.ProdutoBola) rowline.ProdutoBola = 0;
        rowline.ProdutoBola = rowline.ProdutoBola + (soma ? 1 : -1);
        this.util.impact();

    }


    dismiss(force?) {

        //LUPA - Esta no modo pesquisa, finaliza a pesquisa.
        if (this.etapa == 5 && !force && this.clusterIN < 0 && this.produtoText) {
            this.finddata = '';
            this.produtoText = false;
            this.keyboard.close();
            return;
        }

        //GRUPO - Voltando para Visualizar Pedido
        let mesa = this.rootComanda.Comandas[this.comandaIN].Mesa != null;
        let seat = this.rootComanda.Comandas[this.comandaIN].Seat != null;
        if (this.etapa == 5 && !force && this.clusterIN < 0 && !this.requestIpad && mesa && seat) {
            this.consumoLoad();
            return;
        }

        // if (TESTAR) {
        //     //#ConsumoPedy - Limpa para pedir um novo numero de Pedido (fechando e voltando para o menu)
        //     this.akkjson.hotwork.clusterRoot = null;
        //     this.rootComanda.Comandas.forEach(CO => delete CO.Mesa);
        //     this.rootComanda.Comandas.forEach(CO => delete CO.Seat);
        // }

        if (this.navCtrl && this.navCtrl.getPrevious() && this.navCtrl.getPrevious().name == 'CheckinMenuPage') {
            let logado = this.logadoService.getAuth();
            //Hide Support Button Fab
            (window as any).handappMainInstance.supportShow = /*true*/ (logado && logado.Profile.ProfileTeam >= TProfileTeam.mkManager);
        }

        if (this.etapa == 9) this.viewCtrl.dismiss({paymentItem: this.paymentItem()});
        if (this.etapa != 9) this.viewCtrl.dismiss({});

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/lancaki-menu/lancaki-menu.ts